<div class="public-shell">
  <div class="public-shell__content">
    <div class="public-shell__content-inner">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer-layout></app-footer-layout>
</div>
<app-confirm-modal />
<app-toast-container />
